import React, { Component } from 'react';
import { hashHistory } from 'react-router';
import api from '../../api/Categories.api';
import headerActions from './../../reusable/Header/Header.actions';
import popupActions from '../../reusable/MessagePopup/redux/MessagePopup.actions';
import CategoryForm from './Components/CategoryForm';
import { POPUP_LIFETIME } from './../../constants';
import { FormattedMessage } from 'react-intl';

class CreateCategoryPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            validated: false,
            values: {
                name:       '',
                entityIds: []
            },
            pendingRequestSpinner: false,
            errorMessage: null,
            showErrors: false
        };

        this.setValidationState = this.setValidationState.bind(this);
        this.onChange = this.onChange.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        headerActions.updateHeader('createNewCategory');
    }

    onChange(values) {
        this.setState({ values, errorMessage: null });
        if(values && values.entityIds && values.entityIds.length > 0) {
            this.state.showErrors ? this.setState({showErrors: false}) : null;
        }
    }

    requestSaveCategory() {
        if (this.state.validated) {
            this.setState({ pendingRequestSpinner: true });
            api.createCategory({ name: this.state.values.name, companies: this.state.values.entityIds })
                .then((response) => {
                    this.showRequestStatusPopup('Category_Create_UIText_creationSuccess', 'success');
                    hashHistory.push('/categories');
                }).catch((error) => {
                    this.showRequestStatusPopup('General_CoreFunctionality_Error_general.saveError', 'system-error');
                    this.setState({pendingRequestSpinner: false});
                    console.log("********************** Category Save Failed ********************");
                });
        } else {
            this.setState({errorMessage: 'Category_Create_UIText_addCategory.entities.error'});
        }
    }

    showRequestStatusPopup(messageId, messageType) {
        popupActions.setMessages({
            popupTitle: null,
            messages:   [
                {
                    messageId:   messageId,
                    values:      { categoryName: this.state.values.name },
                    messageType: messageType
                }
            ]
        });

        // Hide the message after 5 seconds.
        setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
    }

    setValidationState(state) {
        this.setState({ validated: state })
    }

    cancelButtonRedirect() {
        hashHistory.push("/categories");
    }

    submit() {
        if (this.state.validated && this.state.values.entityIds.length) {
            this.requestSaveCategory();
        } else {
            this.setState({ showErrors: true })
        }
    }

    render = () => (
        <div className="create-category-form category-form">
            { this.state.errorMessage && <FormattedMessage id={this.state.errorMessage}/>}
            <CategoryForm setValidationState={this.setValidationState}
                          onChange={this.onChange}
                          showErrors={this.state.showErrors}/>
            <div className='category-page__navigation'>
                {
                    !this.props.pendingRequestSpinner ?
                        <button type='button'
                                className='button-primary-lg'
                                onClick={this.submit}
                                disabled={!this.state.values || !this.state.values.name}>
                            <FormattedMessage id="General_CoreFunctionality_UIText_general.save" />
                        </button>
                        :
                        <div className='inline-spinner' />
                }
                <button type='button'
                        className='button-secondary-lg'
                        onClick={this.cancelButtonRedirect}
                        disabled={this.state.pendingRequestSpinner}>
                    <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel" />
                </button>
            </div>
        </div>
    );
}

export default CreateCategoryPage;


// WEBPACK FOOTER //
// ./src/scripts/pages/Categories/CreateCategoryPage.jsx